import { useState, useEffect, useRef } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

// Textos bilingues de esta pantalla (incluye el "motor de retos" y cada tipo
// de actividad). El idioma lo controla el selector 🇪🇸 ES / 🇬🇧 EN que ya
// existe en la barra lateral del Dashboard. Importante: esto solo traduce
// los CONTROLES de la interfaz (botones, instrucciones fijas) — el
// contenido real del reto (el slang, la frase, la situacion) viene de la
// base de datos y se mantiene igual, porque es lo que el estudiante esta
// practicando.
const TEXTOS = {
  es: {
    vy: { palabrasAprender:'Palabras que vas a aprender', visteVideo:'Ya vi el video completo', leisteEscena:'Ya leí la escena', continuar:'Continuar' },
    lc: { glosario:'Glosario de slangs', leiTexto:'Leí el texto y entiendo los slangs resaltados', continuar:'Continuar' },
    as: { slangBogotano:'Slang bogotano', escuchar:'Escuchar 🔊', definicion:'Definición:', pregunta:'¿Cuál es la traducción correcta al inglés?', comprobar:'Comprobar', siguiente:'Siguiente' },
    cf: { bancoPalabras:'Banco de palabras', comprobar:'Comprobar', correctas:'correctas', siguiente:'Siguiente' },
    vs: { situacionReal:'Situación real', verEnIngles:'Ver en inglés', pregunta:'¿Cuál es la respuesta más apropiada?', comprobar:'Comprobar', siguiente:'Siguiente' },
    pl: { palabrasSugeridas:'Palabras sugeridas', placeholder:'Escribe aquí en español bogotano...', palabras:'palabras', listo:'✓ Listo', necesitas:'necesitas', mas:'más', enviar:'Enviar', tuRespuesta:'Tu respuesta:', ejemploRespuesta:'Ejemplo de respuesta:', escucharEjemplo:'Escuchar ejemplo 🔊', finalizarReto:'Finalizar reto' },
    ac: { instruccion:'💡 Haz clic en un slang, luego haz clic en su significado en inglés para conectarlos.', slangs:'🇨🇴 Slangs', meanings:'🇬🇧 Significados', coincidencias:'coincidencias correctas', comprobar:'Comprobar respuestas', siguiente:'Siguiente' },
    ee: { oracion:'Oración', de:'de', instruccion:'Haz clic en el altavoz y escribe exactamente lo que escuchas:', placeholder:'Escribe lo que escuchaste en español...', perfecto:'✅ ¡Perfecto! Coincide exacto.', incorrecto:'❌ El texto correcto era:', traduccion:'Traducción:', comprobar:'Comprobar', finalizar:'Finalizar', siguienteFlecha:'Siguiente →', escuchar:'🔊 Escuchar', puedesEscuchar:'Puedes escuchar las veces que necesites' },
    fc: { completadas:'¡Flashcards completadas!', loSabia:'Lo sabía ✓', necesitoRepasar:'Necesito repasar', continuar:'Continuar', tarjeta:'Tarjeta', de:'de', significadoIngles:'Significado en inglés', slangColombiano:'Slang colombiano', clicVerSignificado:'👆 Haz clic para ver el significado', clicPrimero:'Haz clic en la tarjeta primero, y luego dinos si la sabías', mostrarSignificado:'Mostrar significado', escuchar:'🔊 Escuchar', noLoSabia:"❌ No lo sabía", siLoSabia:'✅ ¡Lo sabía!' },
    tr: { completado:'¡Ronda rápida completada!', correctas:'correctas', continuar:'Continuar', palabra:'Palabra', de:'de', traduceAlIngles:'Traduce al inglés' },
    motor: { cargando:'Cargando reto...', completado:'¡Reto completado!', xpGanados:'XP ganados', insigniaDesbloqueada:'Insignia desbloqueada', contenidoExclusivo:'Contenido exclusivo desbloqueado', volver:'Volver a retos', volverFlecha:'← Volver', extra:'Extra', diario:'Diario', reto:'Reto' },
    pantalla: { cargando:'Cargando retos...', video:'Video', lectura:'Lectura', adivina:'Adivina', conecta:'Conecta', dictado:'Dictado', flashcards:'Flashcards', speed:'Velocidad', titulo:'Retos Diarios', subtitulo:'Completa retos para ganar insignias y desbloquear contenido exclusivo del Bogotálogo.', retosDelDia:'Retos del día', retosExtra:'Retos extra opcionales', completado:'Completado', bloqueado:'Bloqueado', extra:'Extra', rehacer:'Rehacer', empezarReto:'Empezar reto', completaAnterior:'Completa el reto anterior' }
  },
  en: {
    vy: { palabrasAprender:"Words you'll learn", visteVideo:"I've watched the full video", leisteEscena:"I've read the scene", continuar:'Continue' },
    lc: { glosario:'Slang glossary', leiTexto:'I read the text and understand the highlighted slang', continuar:'Continue' },
    as: { slangBogotano:'Bogotá slang', escuchar:'Listen 🔊', definicion:'Definition:', pregunta:"What's the correct English translation?", comprobar:'Check', siguiente:'Next' },
    cf: { bancoPalabras:'Word bank', comprobar:'Check', correctas:'correct', siguiente:'Next' },
    vs: { situacionReal:'Real situation', verEnIngles:'See in English', pregunta:'What is the most appropriate response?', comprobar:'Check', siguiente:'Next' },
    pl: { palabrasSugeridas:'Suggested words', placeholder:'Write here in Bogotá Spanish...', palabras:'words', listo:'✓ Ready', necesitas:'need', mas:'more', enviar:'Send', tuRespuesta:'Your answer:', ejemploRespuesta:'Example answer:', escucharEjemplo:'Listen to example 🔊', finalizarReto:'Finish challenge' },
    ac: { instruccion:'💡 Click a slang, then click its English meaning to connect them.', slangs:'🇨🇴 Slangs', meanings:'🇬🇧 Meanings', coincidencias:'correct matches', comprobar:'Check answers', siguiente:'Next' },
    ee: { oracion:'Sentence', de:'of', instruccion:'Click the speaker and write exactly what you hear:', placeholder:'Write what you heard in Spanish...', perfecto:'✅ Perfect! Exact match.', incorrecto:'❌ The correct text was:', traduccion:'Translation:', comprobar:'Check', finalizar:'Finish', siguienteFlecha:'Next →', escuchar:'🔊 Listen', puedesEscuchar:'You can listen as many times as you need' },
    fc: { completadas:'Flashcards complete!', loSabia:'I knew it ✓', necesitoRepasar:'Need review', continuar:'Continue', tarjeta:'Card', de:'of', significadoIngles:'English meaning', slangColombiano:'Colombian slang', clicVerSignificado:'👆 Click to see meaning', clicPrimero:'Click the card first, then tell us if you knew it', mostrarSignificado:'Show meaning', escuchar:'🔊 Listen', noLoSabia:"❌ Didn't know it", siLoSabia:'✅ I knew it!' },
    tr: { completado:'Speed round complete!', correctas:'correct', continuar:'Continue', palabra:'Word', de:'of', traduceAlIngles:'Translate to English' },
    motor: { cargando:'Loading challenge...', completado:'Challenge completed!', xpGanados:'XP earned', insigniaDesbloqueada:'Badge unlocked', contenidoExclusivo:'Exclusive content unlocked', volver:'Back to challenges', volverFlecha:'← Back', extra:'Extra', diario:'Daily', reto:'Challenge' },
    pantalla: { cargando:'Loading challenges...', video:'Video', lectura:'Reading', adivina:'Guess', conecta:'Connect', dictado:'Dictation', flashcards:'Flashcards', speed:'Speed', titulo:'Daily Challenges', subtitulo:'Complete challenges to earn badges and unlock exclusive Bogotálogo content.', retosDelDia:"Today's Challenges", retosExtra:'Optional Extra Challenges', completado:'Completed', bloqueado:'Locked', extra:'Extra', rehacer:'Redo', empezarReto:'Start challenge', completaAnterior:'Complete the previous challenge' }
  }
}

function hablar(texto) {
  if (!window.speechSynthesis) return
  window.speechSynthesis.cancel()
  const u = new SpeechSynthesisUtterance(texto)
  u.lang = 'es-CO'; u.rate = 0.85
  const voces = window.speechSynthesis.getVoices()
  const voz = voces.find(v => v.lang === 'es-CO') || voces.find(v => v.lang.startsWith('es'))
  if (voz) u.voice = voz
  window.speechSynthesis.speak(u)
}

// ── TIPOS EXISTENTES ─────────────────────────────────────

function VideoYoutube({ actividad, onCompletar, t }) {
  const c = actividad.contenido
  const [visto, setVisto] = useState(false)
  return (
    <div>
      <div style={{ marginBottom:20 }}>
        {c.youtube_id && c.youtube_id !== 'dQw4w9WgXcQ' ? (
          <div style={{ position:'relative', paddingBottom:'56.25%', height:0, borderRadius:12, overflow:'hidden', background:'#000' }}>
            <iframe src={'https://www.youtube.com/embed/' + c.youtube_id} title={c.titulo_video}
              style={{ position:'absolute', top:0, left:0, width:'100%', height:'100%', border:'none' }} allowFullScreen />
          </div>
        ) : (
          <div style={{ background:'linear-gradient(135deg,#0D1F52,#1B3A8C)', borderRadius:12, padding:32, color:'#fff', textAlign:'center' }}>
            <div style={{ fontSize:48, marginBottom:12 }}>🎬</div>
            <p style={{ fontSize:15, opacity:.9, lineHeight:1.7, maxWidth:500, margin:'0 auto' }}>{c.sin_video_texto}</p>
          </div>
        )}
      </div>
      <div style={{ background:'#F4F6FA', borderRadius:12, padding:16, marginBottom:20 }}>
        <p style={{ fontSize:13, color:'#374151', lineHeight:1.6, marginBottom:12 }}>{c.descripcion}</p>
        {c.palabras_destacadas && (
          <div>
            <p style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:8, textTransform:'uppercase' }}>{t.vy.palabrasAprender}</p>
            <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
              {c.palabras_destacadas.map((p,i) => (
                <button key={i} onClick={() => hablar(p)}
                  style={{ background:'#7C3AED', color:'#fff', border:'none', borderRadius:8, padding:'6px 14px', fontSize:13, fontWeight:700, cursor:'pointer' }}>
                  {p} 🔊
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', paddingTop:16, borderTop:'1px solid #E2E6F0' }}>
        <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, cursor:'pointer' }}>
          <input type="checkbox" checked={visto} onChange={e => setVisto(e.target.checked)} />
          {c.youtube_id && c.youtube_id !== 'dQw4w9WgXcQ' ? t.vy.visteVideo : t.vy.leisteEscena}
        </label>
        <button disabled={!visto} onClick={() => onCompletar({ xp_ganado: 0 })}
          style={{ background: visto ? '#7C3AED' : '#E2E6F0', color: visto ? '#fff' : '#9CA3AF', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor: visto ? 'pointer' : 'not-allowed' }}>
          {t.vy.continuar}
        </button>
      </div>
    </div>
  )
}

function LecturaContexto({ actividad, onCompletar, t }) {
  const c = actividad.contenido
  const [leido, setLeido] = useState(false)

  function resaltarPalabras(texto, palabrasClave) {
    if (!palabrasClave || palabrasClave.length === 0) return [texto]
    const partes = []
    let textoRestante = texto
    let key = 0
    while (textoRestante.length > 0) {
      let minIdx = textoRestante.length
      let palabraEncontrada = null
      for (const palabra of palabrasClave) {
        const idx = textoRestante.toLowerCase().indexOf(palabra.toLowerCase())
        if (idx >= 0 && idx < minIdx) { minIdx = idx; palabraEncontrada = palabra }
      }
      if (palabraEncontrada && minIdx >= 0) {
        if (minIdx > 0) partes.push(<span key={key++}>{textoRestante.slice(0, minIdx)}</span>)
        partes.push(
          <span key={key++} style={{ background:'#FCD116', color:'#1A1A2E', fontWeight:700, borderRadius:4, padding:'1px 4px', cursor:'pointer' }}
            onClick={() => hablar(palabraEncontrada)}>
            {textoRestante.slice(minIdx, minIdx + palabraEncontrada.length)} 🔊
          </span>
        )
        textoRestante = textoRestante.slice(minIdx + palabraEncontrada.length)
      } else {
        partes.push(<span key={key++}>{textoRestante}</span>)
        break
      }
    }
    return partes
  }

  return (
    <div>
      <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:12, padding:24, marginBottom:20 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:16 }}>
          <span style={{ fontSize:20 }}>📖</span>
          <h3 style={{ fontSize:16, fontWeight:700, color:'#1A1A2E' }}>{c.titulo_texto}</h3>
          <span style={{ marginLeft:'auto', background:'#EDE9FE', color:'#7C3AED', fontSize:11, fontWeight:700, padding:'2px 8px', borderRadius:999 }}>
            {c.contexto === 'bogotano' ? 'Bogotá' : 'Antioquia'}
          </span>
        </div>
        {c.parrafos.map((p, i) => (
          <p key={i} style={{ fontSize:15, lineHeight:1.9, color:'#374151', marginBottom:16 }}>
            {resaltarPalabras(p.texto, p.palabras_clave)}
          </p>
        ))}
      </div>
      {c.glosario && c.glosario.length > 0 && (
        <div style={{ background:'#F5F3FF', border:'1px solid #DDD6FE', borderRadius:12, padding:16, marginBottom:20 }}>
          <p style={{ fontSize:12, fontWeight:700, color:'#7C3AED', marginBottom:12, textTransform:'uppercase', letterSpacing:1 }}>{t.lc.glosario}</p>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(200px, 1fr))', gap:8 }}>
            {c.glosario.map((g, i) => (
              <div key={i} style={{ background:'#fff', borderRadius:8, padding:'10px 12px', border:'1px solid #DDD6FE' }}>
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:4 }}>
                  <span style={{ fontSize:15, fontWeight:800, color:'#7C3AED' }}>{g.palabra}</span>
                  <button onClick={() => hablar(g.palabra)}
                    style={{ background:'#7C3AED', border:'none', borderRadius:6, width:24, height:24, cursor:'pointer', fontSize:11, color:'#fff' }}>
                    🔊
                  </button>
                </div>
                <div style={{ fontSize:12, color:'#374151', marginBottom:2 }}>{g.significado}</div>
                {g.pronunciacion && <div style={{ fontSize:11, color:'#9CA3AF', fontStyle:'italic' }}>/{g.pronunciacion}/</div>}
              </div>
            ))}
          </div>
        </div>
      )}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', paddingTop:16, borderTop:'1px solid #E2E6F0' }}>
        <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, cursor:'pointer' }}>
          <input type="checkbox" checked={leido} onChange={e => setLeido(e.target.checked)} />
          {t.lc.leiTexto}
        </label>
        <button disabled={!leido} onClick={() => onCompletar({ xp_ganado: actividad.xp })}
          style={{ background: leido ? '#7C3AED' : '#E2E6F0', color: leido ? '#fff' : '#9CA3AF', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor: leido ? 'pointer' : 'not-allowed' }}>
          {t.lc.continuar}
        </button>
      </div>
    </div>
  )
}

function AdivinarSlang({ actividad, onCompletar, t }) {
  const c = actividad.contenido
  const [seleccion, setSeleccion] = useState(null)
  const [validado, setValidado] = useState(false)
  const correcta = c.opciones.find(o => o.correcta)
  return (
    <div>
      <div style={{ background:'linear-gradient(135deg,#7C3AED,#4F46E5)', borderRadius:14, padding:24, marginBottom:20, color:'#fff', textAlign:'center' }}>
        <div style={{ fontSize:13, opacity:.7, marginBottom:6, textTransform:'uppercase', letterSpacing:1 }}>{t.as.slangBogotano}</div>
        <div style={{ fontSize:36, fontWeight:900, marginBottom:8 }}>{c.slang}</div>
        <button onClick={() => hablar(c.slang)} style={{ background:'rgba(255,255,255,0.2)', border:'none', borderRadius:8, padding:'6px 14px', color:'#fff', fontSize:13, cursor:'pointer' }}>
          {t.as.escuchar}
        </button>
      </div>
      <div style={{ background:'#F4F6FA', borderRadius:10, padding:14, marginBottom:20, fontSize:14, color:'#374151', lineHeight:1.6 }}>
        <strong>{t.as.definicion}</strong> {c.definicion}
      </div>
      <p style={{ fontSize:14, fontWeight:600, color:'#374151', marginBottom:12 }}>{t.as.pregunta}</p>
      <div style={{ display:'flex', flexDirection:'column', gap:8, marginBottom:20 }}>
        {c.opciones.map(op => {
          let bg = '#fff', border = '#E2E6F0', color = '#1A1A2E'
          if (seleccion === op.id && !validado) { bg = '#EDE9FE'; border = '#7C3AED' }
          if (validado && op.correcta) { bg = '#F0FDF4'; border = '#22C55E'; color = '#166534' }
          if (validado && seleccion === op.id && !op.correcta) { bg = '#FEF2F2'; border = '#EF4444'; color = '#991B1B' }
          return (
            <button key={op.id} onClick={() => !validado && setSeleccion(op.id)}
              style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 16px', border:'2px solid ' + border, borderRadius:10, background:bg, color, fontFamily:'inherit', fontSize:14, cursor: validado ? 'default' : 'pointer', textAlign:'left', width:'100%' }}>
              <span style={{ width:28, height:28, borderRadius:'50%', background:'#E2E6F0', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:800, flexShrink:0 }}>
                {op.id.toUpperCase()}
              </span>
              {op.texto}
            </button>
          )
        })}
      </div>
      {validado && (
        <div style={{ padding:'12px 16px', borderRadius:10, marginBottom:16, fontSize:13,
          background: seleccion === correcta.id ? '#F0FDF4' : '#FEF2F2',
          border:'1px solid ' + (seleccion === correcta.id ? '#22C55E' : '#EF4444'),
          color: seleccion === correcta.id ? '#166534' : '#991B1B' }}>
          {seleccion === correcta.id ? c.feedback_correcto : c.feedback_incorrecto}
        </div>
      )}
      <div style={{ display:'flex', justifyContent:'flex-end' }}>
        {!validado
          ? <button disabled={!seleccion} onClick={() => setValidado(true)}
              style={{ background: seleccion ? '#7C3AED' : '#E2E6F0', color: seleccion ? '#fff' : '#9CA3AF', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor: seleccion ? 'pointer' : 'not-allowed' }}>
              {t.as.comprobar}
            </button>
          : <button onClick={() => onCompletar({ xp_ganado: seleccion === correcta.id ? actividad.xp : Math.round(actividad.xp * 0.3) })}
              style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
              {t.as.siguiente}
            </button>
        }
      </div>
    </div>
  )
}

function CompletarFrase({ actividad, onCompletar, t }) {
  const c = actividad.contenido
  const [resp, setResp] = useState({})
  const [validado, setValidado] = useState(false)
  const [correctas, setCorrectas] = useState(0)

  function validar() {
    let ok = 0
    c.ejercicios.forEach(ej => {
      ej.blancos.forEach(b => {
        if ((resp[ej.id + '-' + b.pos] || '').trim().toLowerCase() === b.correcta.toLowerCase()) ok++
      })
    })
    setCorrectas(ok)
    setValidado(true)
  }

  const total = c.ejercicios.reduce((s, e) => s + e.blancos.length, 0)
  const xpGanado = Math.round((correctas / Math.max(total, 1)) * actividad.xp)

  return (
    <div>
      {c.banco_palabras && c.banco_palabras.length > 0 && (
        <div style={{ background:'#F4F6FA', borderRadius:10, padding:14, marginBottom:20 }}>
          <p style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:8, textTransform:'uppercase' }}>{t.cf.bancoPalabras}</p>
          <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
            {c.banco_palabras.map((p, i) => (
              <button key={i} onClick={() => hablar(p)}
                style={{ background:'#fff', border:'1.5px solid #7C3AED', borderRadius:8, padding:'4px 12px', fontSize:13, color:'#7C3AED', fontWeight:600, cursor:'pointer' }}>
                {p} {c.banco_traduccion && c.banco_traduccion[i] ? '(' + c.banco_traduccion[i] + ')' : ''}
              </button>
            ))}
          </div>
        </div>
      )}
      <div style={{ display:'flex', flexDirection:'column', gap:16, marginBottom:24 }}>
        {c.ejercicios.map((ej, i) => {
          const partes = ej.texto.split('___')
          return (
            <div key={ej.id} style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:10, padding:'14px 16px' }}>
              <div style={{ fontSize:14, lineHeight:2 }}>
                <span style={{ fontWeight:700, color:'#7C3AED', marginRight:8 }}>{i + 1}.</span>
                {partes.map((parte, j) => (
                  <span key={j}>
                    {parte}
                    {j < ej.blancos.length && (
                      <input type="text"
                        value={resp[ej.id + '-' + j] || ''}
                        onChange={e => !validado && setResp(r => Object.assign({}, r, { [ej.id + '-' + j]: e.target.value }))}
                        placeholder={ej.blancos[j] ? ej.blancos[j].pista : '...'}
                        style={{ border:'none', borderBottom:'2px solid #7C3AED', padding:'2px 6px', fontFamily:'inherit', fontSize:14, fontWeight:600, color:'#7C3AED', background:'transparent', outline:'none', margin:'0 4px', width:'120px' }}
                      />
                    )}
                  </span>
                ))}
              </div>
              {ej.traduccion && <div style={{ fontSize:12, color:'#9CA3AF', fontStyle:'italic', marginTop:4 }}>{ej.traduccion}</div>}
            </div>
          )
        })}
      </div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        {!validado
          ? <button onClick={validar} style={{ background:'#7C3AED', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
              {t.cf.comprobar}
            </button>
          : <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%' }}>
              <span style={{ fontSize:14, fontWeight:700, color:'#22C55E' }}>{correctas}/{total} {t.cf.correctas} +{xpGanado} XP</span>
              <button onClick={() => onCompletar({ xp_ganado: xpGanado })}
                style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
                {t.cf.siguiente}
              </button>
            </div>
        }
      </div>
    </div>
  )
}

function VideoSituacion({ actividad, onCompletar, t }) {
  const c = actividad.contenido
  const [seleccion, setSeleccion] = useState(null)
  const [validado, setValidado] = useState(false)
  const correcta = c.opciones.find(o => o.correcta)
  return (
    <div>
      <div style={{ background:'linear-gradient(135deg,#0D1F52,#1B3A8C)', borderRadius:14, padding:20, marginBottom:20, color:'#fff' }}>
        <div style={{ fontSize:12, opacity:.7, marginBottom:8, textTransform:'uppercase', letterSpacing:1 }}>{t.vs.situacionReal}</div>
        <p style={{ fontSize:14, lineHeight:1.7 }}>{c.escena}</p>
        {c.escena_traduccion && (
          <details style={{ marginTop:8 }}>
            <summary style={{ cursor:'pointer', fontSize:12, opacity:.7 }}>{t.vs.verEnIngles}</summary>
            <p style={{ fontSize:12, fontStyle:'italic', opacity:.8, marginTop:4 }}>{c.escena_traduccion}</p>
          </details>
        )}
      </div>
      <p style={{ fontSize:14, fontWeight:600, marginBottom:12 }}>{t.vs.pregunta}</p>
      <div style={{ display:'flex', flexDirection:'column', gap:8, marginBottom:20 }}>
        {c.opciones.map(op => {
          let bg = '#fff', border = '#E2E6F0', color = '#1A1A2E'
          if (seleccion === op.id && !validado) { bg = '#EDE9FE'; border = '#7C3AED' }
          if (validado && op.correcta) { bg = '#F0FDF4'; border = '#22C55E'; color = '#166534' }
          if (validado && seleccion === op.id && !op.correcta) { bg = '#FEF2F2'; border = '#EF4444'; color = '#991B1B' }
          return (
            <button key={op.id} onClick={() => !validado && setSeleccion(op.id)}
              style={{ padding:'12px 16px', border:'2px solid ' + border, borderRadius:10, background:bg, color, fontFamily:'inherit', fontSize:13, cursor: validado ? 'default' : 'pointer', textAlign:'left', width:'100%' }}>
              {op.texto}
            </button>
          )
        })}
      </div>
      {validado && seleccion && (
        <div style={{ padding:'12px 16px', borderRadius:10, marginBottom:16, fontSize:13,
          background: seleccion === correcta.id ? '#F0FDF4' : '#FEF2F2',
          border:'1px solid ' + (seleccion === correcta.id ? '#22C55E' : '#EF4444'),
          color: seleccion === correcta.id ? '#166534' : '#991B1B' }}>
          {c.opciones.find(o => o.id === seleccion)?.feedback || ''}
        </div>
      )}
      <div style={{ display:'flex', justifyContent:'flex-end' }}>
        {!validado
          ? <button disabled={!seleccion} onClick={() => setValidado(true)}
              style={{ background: seleccion ? '#7C3AED' : '#E2E6F0', color: seleccion ? '#fff' : '#9CA3AF', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor: seleccion ? 'pointer' : 'not-allowed' }}>
              {t.vs.comprobar}
            </button>
          : <button onClick={() => onCompletar({ xp_ganado: seleccion === correcta.id ? actividad.xp : Math.round(actividad.xp * 0.3) })}
              style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
              {t.vs.siguiente}
            </button>
        }
      </div>
    </div>
  )
}

function ProduccionLibre({ actividad, onCompletar, t }) {
  const c = actividad.contenido
  const [texto, setTexto] = useState('')
  const [enviado, setEnviado] = useState(false)
  const palabras = texto.trim().split(/\s+/).filter(Boolean)
  const suficiente = palabras.length >= 8
  return (
    <div>
      <div style={{ background:'#FEF0E0', border:'1px solid #F07C1E', borderRadius:12, padding:16, marginBottom:16 }}>
        <p style={{ fontSize:14, fontWeight:600, color:'#92400E', marginBottom:4 }}>{c.prompt}</p>
        {c.prompt_traduccion && <p style={{ fontSize:12, color:'#9CA3AF', fontStyle:'italic' }}>{c.prompt_traduccion}</p>}
      </div>
      {c.palabras_clave && (
        <div style={{ marginBottom:14 }}>
          <p style={{ fontSize:12, fontWeight:600, color:'#6B7280', marginBottom:6, textTransform:'uppercase' }}>{t.pl.palabrasSugeridas}</p>
          <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
            {c.palabras_clave.map((p, i) => (
              <button key={i} onClick={() => hablar(p)}
                style={{ background:'#EDE9FE', border:'1px solid #7C3AED', borderRadius:999, padding:'3px 10px', fontSize:12, color:'#7C3AED', cursor:'pointer' }}>
                {p} {c.palabras_clave_traduccion?.[i] ? '(' + c.palabras_clave_traduccion[i] + ')' : ''}
              </button>
            ))}
          </div>
        </div>
      )}
      {!enviado ? (
        <div>
          <textarea value={texto} onChange={e => setTexto(e.target.value)}
            placeholder={t.pl.placeholder}
            style={{ width:'100%', minHeight:120, padding:'12px 14px', border:'1.5px solid #E2E6F0', borderRadius:10, fontFamily:'inherit', fontSize:14, outline:'none', resize:'vertical', lineHeight:1.6, boxSizing:'border-box' }}
          />
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:8 }}>
            <span style={{ fontSize:12, color: suficiente ? '#22C55E' : '#6B7280' }}>
              {palabras.length} {t.pl.palabras} {suficiente ? t.pl.listo : t.pl.necesitas + ' ' + (8 - palabras.length) + ' ' + t.pl.mas}
            </span>
            <button disabled={!suficiente} onClick={() => setEnviado(true)}
              style={{ background: suficiente ? '#7C3AED' : '#E2E6F0', color: suficiente ? '#fff' : '#9CA3AF', border:'none', borderRadius:10, padding:'9px 20px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor: suficiente ? 'pointer' : 'not-allowed' }}>
              {t.pl.enviar}
            </button>
          </div>
        </div>
      ) : (
        <div>
          <div style={{ background:'#F0FDF4', border:'1px solid #22C55E', borderRadius:10, padding:16, marginBottom:16 }}>
            <p style={{ fontSize:13, fontWeight:600, color:'#166534', marginBottom:8 }}>{t.pl.tuRespuesta}</p>
            <p style={{ fontSize:14, lineHeight:1.7 }}>{texto}</p>
          </div>
          {c.ejemplo_respuesta && (
            <div style={{ background:'#EDE9FE', borderRadius:8, padding:12, marginBottom:16 }}>
              <p style={{ fontSize:13, fontWeight:600, color:'#7C3AED', marginBottom:4 }}>{t.pl.ejemploRespuesta}</p>
              <p style={{ fontSize:13, lineHeight:1.7 }}>{c.ejemplo_respuesta}</p>
              {c.ejemplo_traduccion && <p style={{ fontSize:12, color:'#9CA3AF', fontStyle:'italic', marginTop:4 }}>{c.ejemplo_traduccion}</p>}
              <button onClick={() => hablar(c.ejemplo_respuesta)} style={{ marginTop:8, background:'#7C3AED', border:'none', borderRadius:8, padding:'6px 12px', color:'#fff', fontSize:12, cursor:'pointer' }}>
                {t.pl.escucharEjemplo}
              </button>
            </div>
          )}
          <div style={{ display:'flex', justifyContent:'flex-end' }}>
            <button onClick={() => onCompletar({ xp_ganado: actividad.xp })}
              style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
              {t.pl.finalizarReto}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

// ── NUEVOS TIPOS ─────────────────────────────────────────

function ArrastraConecta({ actividad, onCompletar, t }) {
  const c = actividad.contenido
  const [conexiones, setConexiones] = useState({})
  const [selSlang, setSelSlang] = useState(null)
  const [validado, setValidado] = useState(false)

  const significados = [...c.pares].sort(() => Math.random() - 0.5)

  function handleSlang(id) {
    if (validado) return
    setSelSlang(selSlang === id ? null : id)
  }

  function handleSignificado(sig) {
    if (validado || !selSlang) return
    setConexiones(prev => ({ ...prev, [selSlang]: sig }))
    setSelSlang(null)
  }

  function validar() { setValidado(true) }

  const correctas = c.pares.filter(p => conexiones[p.id] === p.significado).length
  const xpGanado = Math.round((correctas / c.pares.length) * actividad.xp)
  const completo = Object.keys(conexiones).length === c.pares.length

  return (
    <div>
      <div style={{ background:'#F5F3FF', borderRadius:12, padding:16, marginBottom:20 }}>
        <p style={{ fontSize:13, color:'#7C3AED', fontWeight:600 }}>
          {t.ac.instruccion}
        </p>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:24, marginBottom:20 }}>
        <div>
          <p style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:10, textTransform:'uppercase' }}>{t.ac.slangs}</p>
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {c.pares.map(par => {
              const conectado = conexiones[par.id]
              const esCorrecta = validado && conectado === par.significado
              const esIncorrecta = validado && conectado && conectado !== par.significado
              return (
                <button key={par.id} onClick={() => handleSlang(par.id)}
                  style={{ padding:'12px 16px', border:'2px solid ' + (selSlang === par.id ? '#7C3AED' : esCorrecta ? '#22C55E' : esIncorrecta ? '#EF4444' : conectado ? '#7C3AED' : '#E2E6F0'),
                    borderRadius:10, background: selSlang === par.id ? '#EDE9FE' : esCorrecta ? '#F0FDF4' : esIncorrecta ? '#FEF2F2' : conectado ? '#F5F3FF' : '#fff',
                    fontFamily:'inherit', fontSize:14, fontWeight:700, cursor: validado ? 'default' : 'pointer',
                    color: esCorrecta ? '#166534' : esIncorrecta ? '#991B1B' : '#1A1A2E',
                    display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                  <span>{par.slang}</span>
                  {conectado && <span style={{ fontSize:11, color:'#9CA3AF' }}>→ {conectado}</span>}
                </button>
              )
            })}
          </div>
        </div>
        <div>
          <p style={{ fontSize:12, fontWeight:700, color:'#6B7280', marginBottom:10, textTransform:'uppercase' }}>{t.ac.meanings}</p>
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {significados.map((par, i) => {
              const yaUsado = Object.values(conexiones).includes(par.significado)
              return (
                <button key={i} onClick={() => handleSignificado(par.significado)}
                  style={{ padding:'12px 16px', border:'2px solid ' + (yaUsado ? '#22C55E' : selSlang ? '#7C3AED' : '#E2E6F0'),
                    borderRadius:10, background: yaUsado ? '#F0FDF4' : selSlang ? '#F5F3FF' : '#fff',
                    fontFamily:'inherit', fontSize:14, cursor: validado || !selSlang ? 'default' : 'pointer',
                    color: yaUsado ? '#166534' : '#1A1A2E', opacity: yaUsado && !validado ? 0.6 : 1 }}>
                  {par.significado}
                </button>
              )
            })}
          </div>
        </div>
      </div>

      {validado && (
        <div style={{ padding:'12px 16px', borderRadius:10, marginBottom:16, fontSize:13, fontWeight:600,
          background: correctas === c.pares.length ? '#F0FDF4' : '#FEF0E0',
          border:'1px solid ' + (correctas === c.pares.length ? '#22C55E' : '#F07C1E'),
          color: correctas === c.pares.length ? '#166534' : '#92400E' }}>
          {correctas}/{c.pares.length} {t.ac.coincidencias} · +{xpGanado} XP
        </div>
      )}

      <div style={{ display:'flex', justifyContent:'flex-end' }}>
        {!validado
          ? <button disabled={!completo} onClick={validar}
              style={{ background: completo ? '#7C3AED' : '#E2E6F0', color: completo ? '#fff' : '#9CA3AF', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor: completo ? 'pointer' : 'not-allowed' }}>
              {t.ac.comprobar}
            </button>
          : <button onClick={() => onCompletar({ xp_ganado: xpGanado })}
              style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
              {t.ac.siguiente}
            </button>
        }
      </div>
    </div>
  )
}

function EscuchaEscribe({ actividad, onCompletar, t }) {
  const c = actividad.contenido
  const [indice, setIndice] = useState(0)
  const [respuesta, setRespuesta] = useState('')
  const [validado, setValidado] = useState(false)
  const [puntosTotal, setPuntosTotal] = useState(0)
  const [historial, setHistorial] = useState([])

  const frase = c.frases[indice]
  const esUltima = indice === c.frases.length - 1

  function normalizar(txt) {
    return txt.toLowerCase().trim()
      .replace(/[áàä]/g,'a').replace(/[éèë]/g,'e').replace(/[íìï]/g,'i')
      .replace(/[óòö]/g,'o').replace(/[úùü]/g,'u').replace(/ñ/g,'n')
      .replace(/[^a-z0-9\s]/g,'').replace(/\s+/g,' ')
  }

  function validar() {
    const correcta = normalizar(respuesta) === normalizar(frase.texto)
    const xp = correcta ? Math.round(actividad.xp / c.frases.length) : 0
    setPuntosTotal(p => p + xp)
    setHistorial(h => [...h, { frase: frase.texto, respuesta, correcta, traduccion: frase.traduccion }])
    setValidado(true)
  }

  function siguiente() {
    if (esUltima) {
      onCompletar({ xp_ganado: puntosTotal })
    } else {
      setIndice(i => i + 1)
      setRespuesta('')
      setValidado(false)
    }
  }

  const esCorrecta = validado && normalizar(respuesta) === normalizar(frase.texto)

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
        <div style={{ fontSize:12, color:'#6B7280' }}>{t.ee.oracion} {indice + 1} {t.ee.de} {c.frases.length}</div>
        <div style={{ display:'flex', gap:4 }}>
          {c.frases.map((_, i) => (
            <div key={i} style={{ width:24, height:6, borderRadius:999,
              background: i < indice ? '#22C55E' : i === indice ? '#7C3AED' : '#E2E6F0' }} />
          ))}
        </div>
      </div>

      <div style={{ background:'linear-gradient(135deg,#7C3AED,#4F46E5)', borderRadius:14, padding:24, marginBottom:20, color:'#fff', textAlign:'center' }}>
        <p style={{ fontSize:14, opacity:.8, marginBottom:12 }}>{t.ee.instruccion}</p>
        <button onClick={() => hablar(frase.texto)}
          style={{ background:'rgba(255,255,255,0.2)', border:'2px solid rgba(255,255,255,0.4)', borderRadius:12, padding:'12px 28px', color:'#fff', fontSize:16, cursor:'pointer', fontFamily:'inherit', fontWeight:700 }}>
          {t.ee.escuchar}
        </button>
        <p style={{ fontSize:12, opacity:.6, marginTop:10 }}>{t.ee.puedesEscuchar}</p>
      </div>

      <textarea value={respuesta} onChange={e => !validado && setRespuesta(e.target.value)}
        placeholder={t.ee.placeholder}
        style={{ width:'100%', minHeight:80, padding:'12px 14px',
          border:'2px solid ' + (validado ? (esCorrecta ? '#22C55E' : '#EF4444') : '#E2E6F0'),
          borderRadius:10, fontFamily:'inherit', fontSize:14, outline:'none', resize:'none', lineHeight:1.6, boxSizing:'border-box',
          background: validado ? (esCorrecta ? '#F0FDF4' : '#FEF2F2') : '#fff' }}
      />

      {validado && (
        <div style={{ marginTop:12, marginBottom:16 }}>
          <div style={{ padding:'12px 16px', borderRadius:10, fontSize:13,
            background: esCorrecta ? '#F0FDF4' : '#FEF2F2',
            border:'1px solid ' + (esCorrecta ? '#22C55E' : '#EF4444'),
            color: esCorrecta ? '#166534' : '#991B1B', marginBottom:8 }}>
            {esCorrecta ? t.ee.perfecto : t.ee.incorrecto}
          </div>
          {!esCorrecta && (
            <div style={{ background:'#F5F3FF', borderRadius:10, padding:'12px 16px', fontSize:14, fontWeight:600, color:'#7C3AED' }}>
              {frase.texto}
            </div>
          )}
          <div style={{ fontSize:12, color:'#9CA3AF', fontStyle:'italic', marginTop:8 }}>
            {t.ee.traduccion} {frase.traduccion}
          </div>
        </div>
      )}

      <div style={{ display:'flex', justifyContent:'flex-end', marginTop:8 }}>
        {!validado
          ? <button disabled={!respuesta.trim()} onClick={validar}
              style={{ background: respuesta.trim() ? '#7C3AED' : '#E2E6F0', color: respuesta.trim() ? '#fff' : '#9CA3AF', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor: respuesta.trim() ? 'pointer' : 'not-allowed' }}>
              {t.ee.comprobar}
            </button>
          : <button onClick={siguiente}
              style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
              {esUltima ? t.ee.finalizar : t.ee.siguienteFlecha}
            </button>
        }
      </div>
    </div>
  )
}

function Flashcards({ actividad, onCompletar, t }) {
  const c = actividad.contenido
  const [indice, setIndice] = useState(0)
  const [volteada, setVolteada] = useState(false)
  const [sabia, setSabia] = useState([])
  const [noSabia, setNoSabia] = useState([])
  const [terminado, setTerminado] = useState(false)

  const tarjeta = c.tarjetas[indice]
  const esUltima = indice === c.tarjetas.length - 1

  function responder(loSabia) {
    if (loSabia) setSabia(s => [...s, tarjeta.id])
    else setNoSabia(s => [...s, tarjeta.id])

    if (esUltima) setTerminado(true)
    else { setIndice(i => i + 1); setVolteada(false) }
  }

  if (terminado) {
    const xpGanado = Math.round((sabia.length / c.tarjetas.length) * actividad.xp)
    return (
      <div style={{ textAlign:'center', padding:'20px 0' }}>
        <div style={{ fontSize:56, marginBottom:12 }}>🃏</div>
        <h3 style={{ fontSize:20, fontWeight:800, marginBottom:8 }}>{t.fc.completadas}</h3>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:20, maxWidth:300, margin:'0 auto 20px' }}>
          <div style={{ background:'#F0FDF4', borderRadius:12, padding:16, textAlign:'center' }}>
            <div style={{ fontSize:28, fontWeight:900, color:'#22C55E' }}>{sabia.length}</div>
            <div style={{ fontSize:12, color:'#166534' }}>{t.fc.loSabia}</div>
          </div>
          <div style={{ background:'#FEF2F2', borderRadius:12, padding:16, textAlign:'center' }}>
            <div style={{ fontSize:28, fontWeight:900, color:'#EF4444' }}>{noSabia.length}</div>
            <div style={{ fontSize:12, color:'#991B1B' }}>{t.fc.necesitoRepasar}</div>
          </div>
        </div>
        <button onClick={() => onCompletar({ xp_ganado: xpGanado })}
          style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:10, padding:'12px 28px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
          {t.fc.continuar} +{xpGanado} XP
        </button>
      </div>
    )
  }

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
        <div style={{ fontSize:12, color:'#6B7280' }}>{t.fc.tarjeta} {indice + 1} {t.fc.de} {c.tarjetas.length}</div>
        <div style={{ display:'flex', gap:4 }}>
          {c.tarjetas.map((_, i) => (
            <div key={i} style={{ width:20, height:6, borderRadius:999,
              background: sabia.includes(c.tarjetas[i]?.id) ? '#22C55E' : noSabia.includes(c.tarjetas[i]?.id) ? '#EF4444' : i === indice ? '#7C3AED' : '#E2E6F0' }} />
          ))}
        </div>
      </div>

      <div onClick={() => setVolteada(v => !v)}
        style={{ background: volteada ? 'linear-gradient(135deg,#7C3AED,#4F46E5)' : 'linear-gradient(135deg,#0D1F52,#1B3A8C)',
          borderRadius:16, padding:40, marginBottom:20, color:'#fff', textAlign:'center', cursor:'pointer',
          minHeight:160, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
          transition:'all .3s ease', userSelect:'none' }}>
        <div style={{ fontSize:11, opacity:.6, marginBottom:8, textTransform:'uppercase', letterSpacing:1 }}>
          {volteada ? '🇬🇧 ' + t.fc.significadoIngles : '🇨🇴 ' + t.fc.slangColombiano}
        </div>
        <div style={{ fontSize:36, fontWeight:900, marginBottom:8 }}>
          {volteada ? tarjeta.atras : tarjeta.frente}
        </div>
        {volteada && tarjeta.ejemplo && (
          <div style={{ fontSize:13, opacity:.8, fontStyle:'italic', marginTop:8 }}>
            "{tarjeta.ejemplo}"
            <div style={{ fontSize:11, opacity:.7, marginTop:4 }}>{tarjeta.ejemplo_traduccion}</div>
          </div>
        )}
        {!volteada && (
          <div style={{ fontSize:12, opacity:.5, marginTop:8 }}>{t.fc.clicVerSignificado}</div>
        )}
      </div>

      {!volteada ? (
        <div style={{ textAlign:'center' }}>
          <p style={{ fontSize:13, color:'#6B7280', marginBottom:12 }}>
            {t.fc.clicPrimero}
          </p>
          <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
            <button onClick={() => { setVolteada(true) }}
              style={{ background:'#7C3AED', color:'#fff', border:'none', borderRadius:10, padding:'10px 24px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
              {t.fc.mostrarSignificado}
            </button>
          </div>
        </div>
      ) : (
        <div>
          <div style={{ display:'flex', gap:12, marginBottom:8 }}>
            <button onClick={() => { hablar(tarjeta.frente) }}
              style={{ flex:1, padding:'10px', background:'#F5F3FF', color:'#7C3AED', border:'1.5px solid #DDD6FE', borderRadius:10, fontFamily:'inherit', fontSize:13, fontWeight:600, cursor:'pointer' }}>
              {t.fc.escuchar}
            </button>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
            <button onClick={() => responder(false)}
              style={{ padding:'12px', background:'#FEF2F2', color:'#991B1B', border:'2px solid #EF4444', borderRadius:10, fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer' }}>
              {t.fc.noLoSabia}
            </button>
            <button onClick={() => responder(true)}
              style={{ padding:'12px', background:'#F0FDF4', color:'#166534', border:'2px solid #22C55E', borderRadius:10, fontFamily:'inherit', fontSize:14, fontWeight:700, cursor:'pointer' }}>
              {t.fc.siLoSabia}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

function TraduccionRapida({ actividad, onCompletar, t }) {
  const c = actividad.contenido
  const [indice, setIndice] = useState(0)
  const [tiempoRestante, setTiempoRestante] = useState(c.tiempo_por_palabra || 5)
  const [seleccion, setSeleccion] = useState(null)
  const [resultados, setResultados] = useState([])
  const [terminado, setTerminado] = useState(false)
  const timerRef = useRef(null)

  const palabra = c.palabras[indice]
  const esUltima = indice === c.palabras.length - 1

  useEffect(() => {
    if (terminado || seleccion !== null) return
    setTiempoRestante(c.tiempo_por_palabra || 5)
    timerRef.current = setInterval(() => {
      setTiempoRestante(t => {
        if (t <= 1) {
          clearInterval(timerRef.current)
          registrar(null)
          return 0
        }
        return t - 1
      })
    }, 1000)
    return () => clearInterval(timerRef.current)
  }, [indice, terminado])

  function registrar(opcion) {
    clearInterval(timerRef.current)
    const correcta = opcion === palabra.correcta
    setSeleccion(opcion)
    setResultados(r => [...r, { palabra: palabra.palabra, correcta, seleccion: opcion, respuestaCorrecta: palabra.correcta }])
    setTimeout(() => {
      if (esUltima) setTerminado(true)
      else { setIndice(i => i + 1); setSeleccion(null) }
    }, 1200)
  }

  if (terminado) {
    const correctas = resultados.filter(r => r.correcta).length
    const xpGanado = Math.round((correctas / c.palabras.length) * actividad.xp)
    return (
      <div style={{ textAlign:'center', padding:'20px 0' }}>
        <div style={{ fontSize:56, marginBottom:12 }}>⚡</div>
        <h3 style={{ fontSize:20, fontWeight:800, marginBottom:16 }}>{t.tr.completado}</h3>
        <div style={{ background:'linear-gradient(135deg,#7C3AED,#4F46E5)', borderRadius:16, padding:20, color:'#fff', marginBottom:20 }}>
          <div style={{ fontSize:48, fontWeight:900 }}>{correctas}/{c.palabras.length}</div>
          <div style={{ fontSize:14, opacity:.8 }}>{t.tr.correctas} · +{xpGanado} XP</div>
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:8, marginBottom:20 }}>
          {resultados.map((r, i) => (
            <div key={i} style={{ display:'flex', alignItems:'center', gap:10, padding:'8px 14px',
              background: r.correcta ? '#F0FDF4' : '#FEF2F2', borderRadius:10,
              border:'1px solid ' + (r.correcta ? '#22C55E' : '#EF4444') }}>
              <span style={{ fontSize:16 }}>{r.correcta ? '✅' : '❌'}</span>
              <span style={{ fontWeight:700, color:'#1A1A2E' }}>{r.palabra}</span>
              <span style={{ fontSize:12, color:'#6B7280' }}>→</span>
              <span style={{ fontSize:13, color: r.correcta ? '#166534' : '#991B1B' }}>{r.respuestaCorrecta}</span>
            </div>
          ))}
        </div>
        <button onClick={() => onCompletar({ xp_ganado: xpGanado })}
          style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:10, padding:'12px 28px', fontFamily:'inherit', fontSize:14, fontWeight:600, cursor:'pointer' }}>
          {t.tr.continuar} +{xpGanado} XP
        </button>
      </div>
    )
  }

  const pct = (tiempoRestante / (c.tiempo_por_palabra || 5)) * 100
  const opciones = [...palabra.opciones].sort(() => Math.random() - 0.5)

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:6 }}>
          <span style={{ fontSize:12, color:'#6B7280' }}>{t.tr.palabra} {indice + 1} {t.tr.de} {c.palabras.length}</span>
          <span style={{ fontSize:20, fontWeight:900, color: tiempoRestante <= 2 ? '#EF4444' : '#7C3AED' }}>
            ⏱ {tiempoRestante}s
          </span>
        </div>
        <div style={{ height:8, background:'#E2E6F0', borderRadius:999, overflow:'hidden' }}>
          <div style={{ width: pct + '%', height:'100%', borderRadius:999, transition:'width 1s linear',
            background: tiempoRestante <= 2 ? '#EF4444' : tiempoRestante <= 3 ? '#F59E0B' : '#7C3AED' }} />
        </div>
      </div>

      <div style={{ background:'linear-gradient(135deg,#7C3AED,#4F46E5)', borderRadius:14, padding:32, marginBottom:24, color:'#fff', textAlign:'center' }}>
        <div style={{ fontSize:13, opacity:.7, marginBottom:8, textTransform:'uppercase', letterSpacing:1 }}>{t.tr.traduceAlIngles}</div>
        <div style={{ fontSize:48, fontWeight:900, marginBottom:8 }}>{palabra.palabra}</div>
        <button onClick={() => hablar(palabra.palabra)}
          style={{ background:'rgba(255,255,255,0.2)', border:'none', borderRadius:8, padding:'6px 14px', color:'#fff', fontSize:13, cursor:'pointer' }}>
          🔊
        </button>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
        {opciones.map((op, i) => {
          let bg = '#fff', border = '#E2E6F0', color = '#1A1A2E'
          if (seleccion !== null) {
            if (op === palabra.correcta) { bg = '#F0FDF4'; border = '#22C55E'; color = '#166534' }
            else if (op === seleccion) { bg = '#FEF2F2'; border = '#EF4444'; color = '#991B1B' }
          }
          return (
            <button key={i} onClick={() => seleccion === null && registrar(op)}
              style={{ padding:'14px', border:'2px solid ' + border, borderRadius:12, background:bg, color,
                fontFamily:'inherit', fontSize:14, fontWeight:600, cursor: seleccion !== null ? 'default' : 'pointer',
                transition:'all .15s' }}>
              {op}
            </button>
          )
        })}
      </div>
    </div>
  )
}

// ── MOTOR DE RETO ────────────────────────────────────────

function MotorReto({ reto, onVolver, onCompletar, usuario, t }) {
  const [actividades, setActividades] = useState([])
  const [actActual,   setActActual]   = useState(0)
  const [xpTotal,     setXpTotal]     = useState(0)
  const [completado,  setCompletado]  = useState(false)
  const [cargando,    setCargando]    = useState(true)

  useEffect(() => {
    axios.get(API + '/curriculo/retos/' + reto.id + '/actividades')
      .then(r => setActividades(r.data.datos || []))
      .finally(() => setCargando(false))
  }, [reto.id])

  function handleCompletar(datos) {
    const nuevoXp = xpTotal + (datos.xp_ganado || 0)
    setXpTotal(nuevoXp)
    if (actActual < actividades.length - 1) {
      setActActual(i => i + 1)
    } else {
      setCompletado(true)
      if (usuario && usuario.id) {
        axios.post(API + '/curriculo/retos/' + reto.id + '/completar', {
          usuario_id: usuario.id,
          xp_ganado: nuevoXp,
          puntaje: Math.round((nuevoXp / reto.xp_recompensa) * 100)
        }).catch(console.error)
      }
    }
  }

  if (cargando) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:60, color:'#6B7280' }}>
      {t.motor.cargando}
    </div>
  )

  if (completado) return (
    <div style={{ textAlign:'center', padding:60, display:'flex', flexDirection:'column', alignItems:'center', gap:16 }}>
      <div style={{ fontSize:80 }}>{reto.insignia_emoji}</div>
      <h2 style={{ fontSize:28, fontWeight:800, color:'#7C3AED' }}>{t.motor.completado}</h2>
      <p style={{ fontSize:16, color:'#6B7280' }}>{reto.nombre}</p>
      <div style={{ background:'#EDE9FE', borderRadius:16, padding:'16px 32px', fontSize:20, fontWeight:800, color:'#7C3AED' }}>
        +{xpTotal} {t.motor.xpGanados}
      </div>
      <div style={{ background:'linear-gradient(135deg,#7C3AED,#4F46E5)', borderRadius:16, padding:20, color:'#fff', maxWidth:300 }}>
        <div style={{ fontSize:40, marginBottom:8 }}>{reto.insignia_emoji}</div>
        <div style={{ fontSize:16, fontWeight:800 }}>{t.motor.insigniaDesbloqueada}</div>
        <div style={{ fontSize:14, opacity:.8, marginTop:4 }}>{reto.insignia_nombre}</div>
      </div>
      {reto.contenido_exclusivo && (
        <div style={{ background:'#FEF0E0', border:'1px solid #F07C1E', borderRadius:12, padding:16, maxWidth:400, textAlign:'left' }}>
          <div style={{ fontSize:13, fontWeight:700, color:'#92400E', marginBottom:4 }}>{t.motor.contenidoExclusivo}</div>
          <div style={{ fontSize:13, color:'#374151' }}>{reto.contenido_exclusivo}</div>
        </div>
      )}
      <button onClick={onCompletar}
        style={{ background:'#F07C1E', color:'#fff', border:'none', borderRadius:12, padding:'12px 28px', fontFamily:'inherit', fontSize:16, fontWeight:700, cursor:'pointer', marginTop:8 }}>
        {t.motor.volver}
      </button>
    </div>
  )

  const actividad = actividades[actActual]
  if (!actividad) return null

  const TIPOS = {
    video_youtube:    VideoYoutube,
    lectura_contexto: LecturaContexto,
    adivina_slang:    AdivinarSlang,
    completa_frase:   CompletarFrase,
    video_situacion:  VideoSituacion,
    produccion_libre: ProduccionLibre,
    arrastra_conecta: ArrastraConecta,
    escucha_escribe:  EscuchaEscribe,
    flashcards:       Flashcards,
    traduccion_rapida: TraduccionRapida,
  }
  const Componente = TIPOS[actividad.tipo] || ProduccionLibre
  const pct = Math.round((actActual / actividades.length) * 100)
  const ICONOS_TIPO = {
    video_youtube:'🎬', lectura_contexto:'📖', adivina_slang:'🧠',
    completa_frase:'✍️', video_situacion:'🎭', produccion_libre:'💬',
    arrastra_conecta:'🎯', escucha_escribe:'🔊', flashcards:'🃏', traduccion_rapida:'⚡',
  }

  return (
    <div style={{ maxWidth:760, margin:'0 auto' }}>
      <div style={{ display:'flex', alignItems:'center', gap:16, padding:'14px 20px', background:'#fff', border:'1px solid #E2E6F0', borderRadius:14, marginBottom:24 }}>
        <button onClick={onVolver} style={{ background:'none', border:'none', cursor:'pointer', fontSize:13, color:'#6B7280', fontFamily:'inherit' }}>{t.motor.volverFlecha}</button>
        <div style={{ flex:1 }}>
          <div style={{ fontSize:11, fontWeight:800, color:'#7C3AED', textTransform:'uppercase' }}>
            {ICONOS_TIPO[actividad.tipo]} {t.motor.reto} {reto.tipo === 'extra' ? t.motor.extra : t.motor.diario}
          </div>
          <div style={{ fontSize:14, fontWeight:600 }}>{reto.nombre}</div>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:10, flexShrink:0 }}>
          <div style={{ width:120, height:6, background:'#E2E6F0', borderRadius:999, overflow:'hidden' }}>
            <div style={{ width:pct + '%', height:'100%', background:'#7C3AED', borderRadius:999 }} />
          </div>
          <span style={{ fontSize:12, color:'#6B7280' }}>{actActual + 1}/{actividades.length}</span>
        </div>
        <div style={{ background:'#EDE9FE', color:'#7C3AED', borderRadius:999, padding:'4px 12px', fontSize:13, fontWeight:700 }}>
          {xpTotal} XP
        </div>
      </div>
      <div style={{ background:'#fff', border:'1px solid #E2E6F0', borderRadius:14, padding:32 }}>
        <h2 style={{ fontSize:18, fontWeight:700, color:'#1A1A2E', marginBottom:6 }}>{actividad.titulo}</h2>
        {actividad.instruccion && <p style={{ fontSize:13, color:'#6B7280', marginBottom:20 }}>{actividad.instruccion}</p>}
        <Componente key={actividad.id} actividad={actividad} onCompletar={handleCompletar} t={t} />
      </div>
    </div>
  )
}

// ── PANTALLA PRINCIPAL ───────────────────────────────────

export default function Retos({ usuario, idioma = 'es' }) {
  const t = TEXTOS[idioma] || TEXTOS.es
  const [retos,      setRetos]      = useState([])
  const [progreso,   setProgreso]   = useState([])
  const [retoActivo, setRetoActivo] = useState(null)
  const [cargando,   setCargando]   = useState(true)
  const [retosKey,   setRetosKey]   = useState(0)

  useEffect(() => { cargarDatos() }, [usuario, retosKey])

  async function cargarDatos() {
    setCargando(true)
    try {
      const [retosRes, progresoRes] = await Promise.all([
        axios.get(API + '/curriculo/retos'),
        usuario
          ? axios.get(API + '/curriculo/retos/progreso/' + usuario.id).catch(() => ({ data: { datos: [] } }))
          : Promise.resolve({ data: { datos: [] } })
      ])
      setRetos(retosRes.data.datos || [])
      setProgreso(progresoRes.data.datos || [])
    } catch (err) { console.error(err) }
    finally { setCargando(false) }
  }

  function getEstado(reto, index) {
    const prog = progreso.find(p => p.reto_id === reto.id)
    if (prog && prog.estado === 'completado') return 'completado'
    if (index === 0) return 'disponible'
    const anterior = retos[index - 1]
    const progAnterior = progreso.find(p => p.reto_id === (anterior ? anterior.id : null))
    if (progAnterior && progAnterior.estado === 'completado') return 'disponible'
    return 'bloqueado'
  }

  if (retoActivo) return (
    <MotorReto reto={retoActivo} usuario={usuario} t={t}
      onVolver={() => setRetoActivo(null)}
      onCompletar={() => { setRetoActivo(null); setRetosKey(k => k + 1) }}
    />
  )

  const retosDiarios = retos.filter(r => r.tipo === 'diario')
  const retosExtra   = retos.filter(r => r.tipo === 'extra')

  if (cargando) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:60, color:'#6B7280' }}>
      {t.pantalla.cargando}
    </div>
  )

  function TarjetaReto({ reto, index }) {
    const estado = getEstado(reto, index)
    const bloqueado = estado === 'bloqueado'
    const completado = estado === 'completado'
    return (
      <div style={{ background: completado ? '#F5F3FF' : bloqueado ? '#F9FAFB' : '#fff',
        border:'1.5px solid ' + (completado ? '#7C3AED' : '#E2E6F0'),
        borderRadius:14, padding:20, opacity: bloqueado ? 0.6 : 1 }}>
        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:12 }}>
          <div style={{ fontSize:36 }}>{reto.insignia_emoji}</div>
          <div style={{ flex:1 }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:2 }}>
              {completado && <span style={{ fontSize:11, background:'#7C3AED', color:'#fff', padding:'1px 8px', borderRadius:999, fontWeight:700 }}>{t.pantalla.completado}</span>}
              {bloqueado && <span style={{ fontSize:11, color:'#9CA3AF' }}>{t.pantalla.bloqueado}</span>}
              {reto.tipo === 'extra' && <span style={{ fontSize:11, background:'#FEF0E0', color:'#F07C1E', padding:'1px 8px', borderRadius:999, fontWeight:700 }}>{t.pantalla.extra}</span>}
            </div>
            <div style={{ fontSize:16, fontWeight:700, color: bloqueado ? '#9CA3AF' : '#1A1A2E' }}>{reto.nombre}</div>
          </div>
          <div style={{ textAlign:'right' }}>
            <div style={{ fontSize:18, fontWeight:800, color:'#7C3AED' }}>{reto.xp_recompensa} XP</div>
          </div>
        </div>
        <p style={{ fontSize:13, color:'#6B7280', marginBottom:16, lineHeight:1.5 }}>{reto.descripcion}</p>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <div style={{ fontSize:12, color:'#9CA3AF' }}>{reto.insignia_nombre}</div>
          {!bloqueado && (
            <button onClick={() => setRetoActivo(reto)}
              style={{ background: completado ? '#EDE9FE' : '#7C3AED', color: completado ? '#7C3AED' : '#fff', border:'none', borderRadius:10, padding:'8px 20px', fontFamily:'inherit', fontSize:13, fontWeight:600, cursor:'pointer' }}>
              {completado ? t.pantalla.rehacer : t.pantalla.empezarReto}
            </button>
          )}
          {bloqueado && <div style={{ fontSize:12, color:'#9CA3AF' }}>{t.pantalla.completaAnterior}</div>}
        </div>
      </div>
    )
  }

  return (
    <div style={{ maxWidth:900, margin:'0 auto' }}>
      <div style={{ background:'linear-gradient(135deg,#4F46E5,#7C3AED)', borderRadius:16, padding:24, marginBottom:28, color:'#fff' }}>
        <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:12 }}>
          <span style={{ fontSize:36 }}>🏆</span>
          <div>
            <h1 style={{ fontSize:22, fontWeight:800, marginBottom:2 }}>{t.pantalla.titulo}</h1>
            <p style={{ fontSize:13, opacity:.8 }}>{t.pantalla.subtitulo}</p>
          </div>
        </div>
        <div style={{ display:'flex', gap:16, flexWrap:'wrap' }}>
          {[
            { ic:'🎬', label:t.pantalla.video },
            { ic:'📖', label:t.pantalla.lectura },
            { ic:'🧠', label:t.pantalla.adivina },
            { ic:'🎯', label:t.pantalla.conecta },
            { ic:'🔊', label:t.pantalla.dictado },
            { ic:'🃏', label:t.pantalla.flashcards },
            { ic:'⚡', label:t.pantalla.speed },
          ].map((item, i) => (
            <div key={i} style={{ display:'flex', alignItems:'center', gap:5, fontSize:12, opacity:.85 }}>
              <span>{item.ic}</span><span>{item.label}</span>
            </div>
          ))}
        </div>
      </div>
      <div style={{ marginBottom:32 }}>
        <h2 style={{ fontSize:18, fontWeight:700, color:'#1A1A2E', marginBottom:16 }}>{t.pantalla.retosDelDia}</h2>
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          {retosDiarios.map((r, i) => <TarjetaReto key={r.id} reto={r} index={i} />)}
        </div>
      </div>
      {retosExtra.length > 0 && (
        <div>
          <h2 style={{ fontSize:18, fontWeight:700, color:'#1A1A2E', marginBottom:16 }}>{t.pantalla.retosExtra}</h2>
          <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
            {retosExtra.map((r, i) => <TarjetaReto key={r.id} reto={r} index={retosDiarios.length + i} />)}
          </div>
        </div>
      )}
    </div>
  )
}
